import Dashboard from '../src/Dashboard/index';
export default Dashboard;
